import type { IDockviewDefaultTabProps } from 'dockview';
import { DefaultTabComponent } from './DefaultTabComponent';

export const TAB_COMPONENTS = {
  custom: DefaultTabComponent,
  readOnly: (props: IDockviewDefaultTabProps) => {
    return <DefaultTabComponent hideClose={true} {...props} />;
  },
};
